export default [
  {
    "id": 168739480,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNjg3Mzk0ODA=",
    "name": "2048-Clone",
    "full_name": "rjgupta/2048-Clone",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/2048-Clone",
    "description": "Build a clone of 2048 game in iOS with Swift for CS541 Game Dev for Mobile Platform",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/2048-Clone",
    "forks_url": "https://api.github.com/repos/rjgupta/2048-Clone/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/2048-Clone/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/2048-Clone/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/2048-Clone/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/2048-Clone/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/2048-Clone/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/2048-Clone/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/2048-Clone/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/2048-Clone/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/2048-Clone/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/2048-Clone/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/2048-Clone/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/2048-Clone/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/2048-Clone/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/2048-Clone/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/2048-Clone/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/2048-Clone/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/2048-Clone/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/2048-Clone/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/2048-Clone/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/2048-Clone/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/2048-Clone/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/2048-Clone/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/2048-Clone/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/2048-Clone/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/2048-Clone/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/2048-Clone/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/2048-Clone/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/2048-Clone/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/2048-Clone/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/2048-Clone/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/2048-Clone/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/2048-Clone/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/2048-Clone/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/2048-Clone/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/2048-Clone/deployments",
    "created_at": "2019-02-01T18:06:28Z",
    "updated_at": "2019-11-17T07:26:01Z",
    "pushed_at": "2019-02-14T22:02:30Z",
    "git_url": "git://github.com/rjgupta/2048-Clone.git",
    "ssh_url": "git@github.com:rjgupta/2048-Clone.git",
    "clone_url": "https://github.com/rjgupta/2048-Clone.git",
    "svn_url": "https://github.com/rjgupta/2048-Clone",
    "homepage": null,
    "size": 274,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "Swift",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "master"
  },
  {
    "id": 154224989,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNTQyMjQ5ODk=",
    "name": "Arcade-Game",
    "full_name": "rjgupta/Arcade-Game",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/Arcade-Game",
    "description": "Clone of the classic arcade game Frogger.",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/Arcade-Game",
    "forks_url": "https://api.github.com/repos/rjgupta/Arcade-Game/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/Arcade-Game/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/Arcade-Game/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/Arcade-Game/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/Arcade-Game/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/Arcade-Game/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/Arcade-Game/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/Arcade-Game/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/Arcade-Game/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/Arcade-Game/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/Arcade-Game/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/Arcade-Game/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/Arcade-Game/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/Arcade-Game/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/Arcade-Game/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/Arcade-Game/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/Arcade-Game/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/Arcade-Game/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/Arcade-Game/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/Arcade-Game/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/Arcade-Game/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/Arcade-Game/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/Arcade-Game/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/Arcade-Game/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/Arcade-Game/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/Arcade-Game/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/Arcade-Game/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/Arcade-Game/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/Arcade-Game/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/Arcade-Game/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/Arcade-Game/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/Arcade-Game/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/Arcade-Game/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/Arcade-Game/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/Arcade-Game/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/Arcade-Game/deployments",
    "created_at": "2018-10-22T22:20:33Z",
    "updated_at": "2019-11-17T07:25:57Z",
    "pushed_at": "2018-10-31T19:18:32Z",
    "git_url": "git://github.com/rjgupta/Arcade-Game.git",
    "ssh_url": "git@github.com:rjgupta/Arcade-Game.git",
    "clone_url": "https://github.com/rjgupta/Arcade-Game.git",
    "svn_url": "https://github.com/rjgupta/Arcade-Game",
    "homepage": "https://imrajatgupta.github.io/arcade-game/",
    "size": 253,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "master"
  },
  {
    "id": 130802047,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMzA4MDIwNDc=",
    "name": "awesome-courses",
    "full_name": "rjgupta/awesome-courses",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/awesome-courses",
    "description": "List of awesome university courses for learning Computer Science!",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/awesome-courses",
    "forks_url": "https://api.github.com/repos/rjgupta/awesome-courses/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/awesome-courses/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/awesome-courses/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/awesome-courses/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/awesome-courses/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/awesome-courses/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/awesome-courses/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/awesome-courses/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/awesome-courses/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/awesome-courses/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/awesome-courses/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/awesome-courses/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/awesome-courses/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/awesome-courses/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/awesome-courses/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/awesome-courses/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/awesome-courses/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/awesome-courses/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/awesome-courses/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/awesome-courses/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/awesome-courses/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/awesome-courses/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/awesome-courses/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/awesome-courses/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/awesome-courses/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/awesome-courses/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/awesome-courses/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/awesome-courses/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/awesome-courses/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/awesome-courses/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/awesome-courses/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/awesome-courses/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/awesome-courses/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/awesome-courses/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/awesome-courses/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/awesome-courses/deployments",
    "created_at": "2018-04-24T05:42:35Z",
    "updated_at": "2018-04-24T05:42:37Z",
    "pushed_at": "2015-01-12T08:02:03Z",
    "git_url": "git://github.com/rjgupta/awesome-courses.git",
    "ssh_url": "git@github.com:rjgupta/awesome-courses.git",
    "clone_url": "https://github.com/rjgupta/awesome-courses.git",
    "svn_url": "https://github.com/rjgupta/awesome-courses",
    "homepage": null,
    "size": 227,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 266928194,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNjY5MjgxOTQ=",
    "name": "Awesome-CV",
    "full_name": "rjgupta/Awesome-CV",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/Awesome-CV",
    "description": ":page_facing_up: Awesome CV is LaTeX template for your outstanding job application",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/Awesome-CV",
    "forks_url": "https://api.github.com/repos/rjgupta/Awesome-CV/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/Awesome-CV/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/Awesome-CV/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/Awesome-CV/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/Awesome-CV/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/Awesome-CV/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/Awesome-CV/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/Awesome-CV/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/Awesome-CV/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/Awesome-CV/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/Awesome-CV/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/Awesome-CV/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/Awesome-CV/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/Awesome-CV/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/Awesome-CV/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/Awesome-CV/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/Awesome-CV/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/Awesome-CV/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/Awesome-CV/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/Awesome-CV/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/Awesome-CV/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/Awesome-CV/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/Awesome-CV/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/Awesome-CV/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/Awesome-CV/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/Awesome-CV/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/Awesome-CV/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/Awesome-CV/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/Awesome-CV/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/Awesome-CV/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/Awesome-CV/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/Awesome-CV/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/Awesome-CV/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/Awesome-CV/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/Awesome-CV/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/Awesome-CV/deployments",
    "created_at": "2020-05-26T02:42:21Z",
    "updated_at": "2020-05-26T02:42:22Z",
    "pushed_at": "2020-05-24T21:02:17Z",
    "git_url": "git://github.com/rjgupta/Awesome-CV.git",
    "ssh_url": "git@github.com:rjgupta/Awesome-CV.git",
    "clone_url": "https://github.com/rjgupta/Awesome-CV.git",
    "svn_url": "https://github.com/rjgupta/Awesome-CV",
    "homepage": "",
    "size": 15851,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 128722336,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjg3MjIzMzY=",
    "name": "Challan",
    "full_name": "rjgupta/Challan",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/Challan",
    "description": "A Java Swing Application for Police Stations to record Traffic Fines and Vehicle Registrations in India.",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/Challan",
    "forks_url": "https://api.github.com/repos/rjgupta/Challan/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/Challan/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/Challan/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/Challan/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/Challan/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/Challan/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/Challan/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/Challan/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/Challan/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/Challan/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/Challan/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/Challan/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/Challan/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/Challan/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/Challan/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/Challan/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/Challan/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/Challan/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/Challan/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/Challan/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/Challan/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/Challan/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/Challan/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/Challan/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/Challan/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/Challan/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/Challan/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/Challan/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/Challan/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/Challan/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/Challan/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/Challan/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/Challan/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/Challan/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/Challan/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/Challan/deployments",
    "created_at": "2018-04-09T06:04:30Z",
    "updated_at": "2020-05-07T19:11:14Z",
    "pushed_at": "2018-04-18T17:02:29Z",
    "git_url": "git://github.com/rjgupta/Challan.git",
    "ssh_url": "git@github.com:rjgupta/Challan.git",
    "clone_url": "https://github.com/rjgupta/Challan.git",
    "svn_url": "https://github.com/rjgupta/Challan",
    "homepage": null,
    "size": 18826,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Java",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": true,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 130821193,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMzA4MjExOTM=",
    "name": "ChatApp_RMI",
    "full_name": "rjgupta/ChatApp_RMI",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/ChatApp_RMI",
    "description": "A Chatting Application with Remote Method Invocation written in Java.",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/ChatApp_RMI",
    "forks_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/ChatApp_RMI/deployments",
    "created_at": "2018-04-24T08:24:13Z",
    "updated_at": "2020-05-07T19:11:01Z",
    "pushed_at": "2018-04-24T08:29:13Z",
    "git_url": "git://github.com/rjgupta/ChatApp_RMI.git",
    "ssh_url": "git@github.com:rjgupta/ChatApp_RMI.git",
    "clone_url": "https://github.com/rjgupta/ChatApp_RMI.git",
    "svn_url": "https://github.com/rjgupta/ChatApp_RMI",
    "homepage": null,
    "size": 7,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Java",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": true,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 125632907,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjU2MzI5MDc=",
    "name": "clean_and_clear",
    "full_name": "rjgupta/clean_and_clear",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/clean_and_clear",
    "description": "A Responsive template built in Bootstrap Framework",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/clean_and_clear",
    "forks_url": "https://api.github.com/repos/rjgupta/clean_and_clear/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/clean_and_clear/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/clean_and_clear/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/clean_and_clear/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/clean_and_clear/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/clean_and_clear/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/clean_and_clear/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/clean_and_clear/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/clean_and_clear/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/clean_and_clear/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/clean_and_clear/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/clean_and_clear/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/clean_and_clear/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/clean_and_clear/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/clean_and_clear/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/clean_and_clear/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/clean_and_clear/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/clean_and_clear/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/clean_and_clear/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/clean_and_clear/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/clean_and_clear/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/clean_and_clear/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/clean_and_clear/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/clean_and_clear/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/clean_and_clear/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/clean_and_clear/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/clean_and_clear/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/clean_and_clear/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/clean_and_clear/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/clean_and_clear/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/clean_and_clear/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/clean_and_clear/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/clean_and_clear/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/clean_and_clear/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/clean_and_clear/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/clean_and_clear/deployments",
    "created_at": "2018-03-17T13:40:12Z",
    "updated_at": "2018-03-17T14:08:23Z",
    "pushed_at": "2018-03-17T14:08:22Z",
    "git_url": "git://github.com/rjgupta/clean_and_clear.git",
    "ssh_url": "git@github.com:rjgupta/clean_and_clear.git",
    "clone_url": "https://github.com/rjgupta/clean_and_clear.git",
    "svn_url": "https://github.com/rjgupta/clean_and_clear",
    "homepage": null,
    "size": 657,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "gpl-3.0",
      "name": "GNU General Public License v3.0",
      "spdx_id": "GPL-3.0",
      "url": "https://api.github.com/licenses/gpl-3.0",
      "node_id": "MDc6TGljZW5zZTk="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 254987826,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTQ5ODc4MjY=",
    "name": "code_snippets",
    "full_name": "rjgupta/code_snippets",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/code_snippets",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/code_snippets",
    "forks_url": "https://api.github.com/repos/rjgupta/code_snippets/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/code_snippets/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/code_snippets/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/code_snippets/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/code_snippets/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/code_snippets/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/code_snippets/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/code_snippets/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/code_snippets/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/code_snippets/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/code_snippets/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/code_snippets/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/code_snippets/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/code_snippets/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/code_snippets/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/code_snippets/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/code_snippets/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/code_snippets/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/code_snippets/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/code_snippets/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/code_snippets/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/code_snippets/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/code_snippets/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/code_snippets/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/code_snippets/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/code_snippets/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/code_snippets/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/code_snippets/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/code_snippets/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/code_snippets/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/code_snippets/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/code_snippets/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/code_snippets/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/code_snippets/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/code_snippets/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/code_snippets/deployments",
    "created_at": "2020-04-12T01:34:43Z",
    "updated_at": "2020-04-12T01:34:45Z",
    "pushed_at": "2020-04-01T15:36:50Z",
    "git_url": "git://github.com/rjgupta/code_snippets.git",
    "ssh_url": "git@github.com:rjgupta/code_snippets.git",
    "clone_url": "https://github.com/rjgupta/code_snippets.git",
    "svn_url": "https://github.com/rjgupta/code_snippets",
    "homepage": null,
    "size": 153118,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 242432066,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNDI0MzIwNjY=",
    "name": "complete-javascript-course",
    "full_name": "rjgupta/complete-javascript-course",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/complete-javascript-course",
    "description": "Starter files, final projects and FAQ for my Complete JavaScript course",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/complete-javascript-course",
    "forks_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/complete-javascript-course/deployments",
    "created_at": "2020-02-23T00:24:59Z",
    "updated_at": "2020-02-23T00:25:00Z",
    "pushed_at": "2020-02-10T19:20:07Z",
    "git_url": "git://github.com/rjgupta/complete-javascript-course.git",
    "ssh_url": "git@github.com:rjgupta/complete-javascript-course.git",
    "clone_url": "https://github.com/rjgupta/complete-javascript-course.git",
    "svn_url": "https://github.com/rjgupta/complete-javascript-course",
    "homepage": "https://www.udemy.com/the-complete-javascript-course/?couponCode=C3GITHUB10",
    "size": 28284,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 136634770,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMzY2MzQ3NzA=",
    "name": "course-JS-and-the-DOM",
    "full_name": "rjgupta/course-JS-and-the-DOM",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/course-JS-and-the-DOM",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM",
    "forks_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/course-JS-and-the-DOM/deployments",
    "created_at": "2018-06-08T15:14:04Z",
    "updated_at": "2018-06-08T15:14:07Z",
    "pushed_at": "2018-04-16T10:31:35Z",
    "git_url": "git://github.com/rjgupta/course-JS-and-the-DOM.git",
    "ssh_url": "git@github.com:rjgupta/course-JS-and-the-DOM.git",
    "clone_url": "https://github.com/rjgupta/course-JS-and-the-DOM.git",
    "svn_url": "https://github.com/rjgupta/course-JS-and-the-DOM",
    "homepage": null,
    "size": 43407,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 163268391,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNjMyNjgzOTE=",
    "name": "CS-Books",
    "full_name": "rjgupta/CS-Books",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/CS-Books",
    "description": "A collection of books for Computer Science courses. ",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/CS-Books",
    "forks_url": "https://api.github.com/repos/rjgupta/CS-Books/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/CS-Books/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/CS-Books/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/CS-Books/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/CS-Books/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/CS-Books/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/CS-Books/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/CS-Books/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/CS-Books/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/CS-Books/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/CS-Books/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/CS-Books/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/CS-Books/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/CS-Books/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/CS-Books/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/CS-Books/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/CS-Books/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/CS-Books/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/CS-Books/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/CS-Books/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/CS-Books/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/CS-Books/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/CS-Books/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/CS-Books/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/CS-Books/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/CS-Books/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/CS-Books/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/CS-Books/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/CS-Books/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/CS-Books/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/CS-Books/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/CS-Books/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/CS-Books/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/CS-Books/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/CS-Books/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/CS-Books/deployments",
    "created_at": "2018-12-27T08:26:43Z",
    "updated_at": "2019-11-11T06:02:06Z",
    "pushed_at": "2018-12-27T08:26:43Z",
    "git_url": "git://github.com/rjgupta/CS-Books.git",
    "ssh_url": "git@github.com:rjgupta/CS-Books.git",
    "clone_url": "https://github.com/rjgupta/CS-Books.git",
    "svn_url": "https://github.com/rjgupta/CS-Books",
    "homepage": null,
    "size": 0,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "master"
  },
  {
    "id": 146033434,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDYwMzM0MzQ=",
    "name": "CS575-Design_and_Analysis_of_Algorithms",
    "full_name": "rjgupta/CS575-Design_and_Analysis_of_Algorithms",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/CS575-Design_and_Analysis_of_Algorithms",
    "description": "Implementing Algorithms in C to solve problems",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms",
    "forks_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/CS575-Design_and_Analysis_of_Algorithms/deployments",
    "created_at": "2018-08-24T19:46:32Z",
    "updated_at": "2018-12-13T07:53:59Z",
    "pushed_at": "2018-12-13T07:52:15Z",
    "git_url": "git://github.com/rjgupta/CS575-Design_and_Analysis_of_Algorithms.git",
    "ssh_url": "git@github.com:rjgupta/CS575-Design_and_Analysis_of_Algorithms.git",
    "clone_url": "https://github.com/rjgupta/CS575-Design_and_Analysis_of_Algorithms.git",
    "svn_url": "https://github.com/rjgupta/CS575-Design_and_Analysis_of_Algorithms",
    "homepage": "",
    "size": 82581,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 146033112,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDYwMzMxMTI=",
    "name": "CS580U-Programming_Systems_and_Tools",
    "full_name": "rjgupta/CS580U-Programming_Systems_and_Tools",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/CS580U-Programming_Systems_and_Tools",
    "description": "Repository for subject CS580U - Programming Systems and Tools at Binghamton University. Working with C on Linux",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools",
    "forks_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/CS580U-Programming_Systems_and_Tools/deployments",
    "created_at": "2018-08-24T19:42:39Z",
    "updated_at": "2019-11-11T06:02:11Z",
    "pushed_at": "2018-12-13T07:07:15Z",
    "git_url": "git://github.com/rjgupta/CS580U-Programming_Systems_and_Tools.git",
    "ssh_url": "git@github.com:rjgupta/CS580U-Programming_Systems_and_Tools.git",
    "clone_url": "https://github.com/rjgupta/CS580U-Programming_Systems_and_Tools.git",
    "svn_url": "https://github.com/rjgupta/CS580U-Programming_Systems_and_Tools",
    "homepage": null,
    "size": 9424,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "C",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "master"
  },
  {
    "id": 163268682,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNjMyNjg2ODI=",
    "name": "CtCI-6th-Edition",
    "full_name": "rjgupta/CtCI-6th-Edition",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/CtCI-6th-Edition",
    "description": "Cracking the Coding Interview 6th Ed. Solutions",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition",
    "forks_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/CtCI-6th-Edition/deployments",
    "created_at": "2018-12-27T08:29:31Z",
    "updated_at": "2018-12-27T08:29:34Z",
    "pushed_at": "2018-12-15T16:38:00Z",
    "git_url": "git://github.com/rjgupta/CtCI-6th-Edition.git",
    "ssh_url": "git@github.com:rjgupta/CtCI-6th-Edition.git",
    "clone_url": "https://github.com/rjgupta/CtCI-6th-Edition.git",
    "svn_url": "https://github.com/rjgupta/CtCI-6th-Edition",
    "homepage": "",
    "size": 21487,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Java",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 259083835,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTkwODM4MzU=",
    "name": "django_blog_app",
    "full_name": "rjgupta/django_blog_app",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/django_blog_app",
    "description": "A blog web app built on Django and Database on Postgres",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/django_blog_app",
    "forks_url": "https://api.github.com/repos/rjgupta/django_blog_app/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/django_blog_app/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/django_blog_app/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/django_blog_app/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/django_blog_app/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/django_blog_app/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/django_blog_app/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/django_blog_app/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/django_blog_app/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/django_blog_app/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/django_blog_app/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/django_blog_app/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/django_blog_app/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/django_blog_app/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/django_blog_app/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/django_blog_app/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/django_blog_app/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/django_blog_app/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/django_blog_app/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/django_blog_app/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/django_blog_app/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/django_blog_app/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/django_blog_app/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/django_blog_app/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/django_blog_app/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/django_blog_app/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/django_blog_app/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/django_blog_app/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/django_blog_app/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/django_blog_app/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/django_blog_app/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/django_blog_app/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/django_blog_app/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/django_blog_app/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/django_blog_app/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/django_blog_app/deployments",
    "created_at": "2020-04-26T16:51:18Z",
    "updated_at": "2020-04-29T21:09:57Z",
    "pushed_at": "2020-04-29T21:09:54Z",
    "git_url": "git://github.com/rjgupta/django_blog_app.git",
    "ssh_url": "git@github.com:rjgupta/django_blog_app.git",
    "clone_url": "https://github.com/rjgupta/django_blog_app.git",
    "svn_url": "https://github.com/rjgupta/django_blog_app",
    "homepage": null,
    "size": 1463,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Python",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 147052451,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDcwNTI0NTE=",
    "name": "DL_PyTorch",
    "full_name": "rjgupta/DL_PyTorch",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/DL_PyTorch",
    "description": "Code for the Deep Learning with PyTorch lesson",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/DL_PyTorch",
    "forks_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/DL_PyTorch/deployments",
    "created_at": "2018-09-02T03:51:41Z",
    "updated_at": "2018-09-02T03:51:43Z",
    "pushed_at": "2018-05-22T21:40:09Z",
    "git_url": "git://github.com/rjgupta/DL_PyTorch.git",
    "ssh_url": "git@github.com:rjgupta/DL_PyTorch.git",
    "clone_url": "https://github.com/rjgupta/DL_PyTorch.git",
    "svn_url": "https://github.com/rjgupta/DL_PyTorch",
    "homepage": null,
    "size": 12499,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Jupyter Notebook",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 128264755,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjgyNjQ3NTU=",
    "name": "docs",
    "full_name": "rjgupta/docs",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/docs",
    "description": "The MongoDB Documentation Project Source.",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/docs",
    "forks_url": "https://api.github.com/repos/rjgupta/docs/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/docs/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/docs/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/docs/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/docs/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/docs/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/docs/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/docs/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/docs/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/docs/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/docs/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/docs/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/docs/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/docs/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/docs/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/docs/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/docs/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/docs/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/docs/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/docs/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/docs/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/docs/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/docs/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/docs/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/docs/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/docs/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/docs/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/docs/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/docs/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/docs/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/docs/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/docs/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/docs/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/docs/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/docs/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/docs/deployments",
    "created_at": "2018-04-05T21:11:14Z",
    "updated_at": "2018-04-05T21:11:33Z",
    "pushed_at": "2018-04-05T16:50:48Z",
    "git_url": "git://github.com/rjgupta/docs.git",
    "ssh_url": "git@github.com:rjgupta/docs.git",
    "clone_url": "https://github.com/rjgupta/docs.git",
    "svn_url": "https://github.com/rjgupta/docs",
    "homepage": "http://docs.mongodb.org",
    "size": 69465,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Python",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 156872230,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNTY4NzIyMzA=",
    "name": "easy-application",
    "full_name": "rjgupta/easy-application",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/easy-application",
    "description": "400 software engineering companies that are easy to apply to",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/easy-application",
    "forks_url": "https://api.github.com/repos/rjgupta/easy-application/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/easy-application/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/easy-application/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/easy-application/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/easy-application/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/easy-application/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/easy-application/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/easy-application/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/easy-application/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/easy-application/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/easy-application/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/easy-application/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/easy-application/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/easy-application/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/easy-application/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/easy-application/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/easy-application/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/easy-application/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/easy-application/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/easy-application/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/easy-application/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/easy-application/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/easy-application/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/easy-application/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/easy-application/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/easy-application/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/easy-application/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/easy-application/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/easy-application/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/easy-application/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/easy-application/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/easy-application/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/easy-application/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/easy-application/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/easy-application/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/easy-application/deployments",
    "created_at": "2018-11-09T14:21:27Z",
    "updated_at": "2020-05-07T18:52:58Z",
    "pushed_at": "2017-06-01T17:50:05Z",
    "git_url": "git://github.com/rjgupta/easy-application.git",
    "ssh_url": "git@github.com:rjgupta/easy-application.git",
    "clone_url": "https://github.com/rjgupta/easy-application.git",
    "svn_url": "https://github.com/rjgupta/easy-application",
    "homepage": "http://j-delaney.github.io/easy-application/",
    "size": 198,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": true,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 156018085,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNTYwMTgwODU=",
    "name": "feed-reader-testing",
    "full_name": "rjgupta/feed-reader-testing",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/feed-reader-testing",
    "description": "A web-based application that reads RSS feeds. This project does testing using Jasmine.",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/feed-reader-testing",
    "forks_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/feed-reader-testing/deployments",
    "created_at": "2018-11-03T19:46:51Z",
    "updated_at": "2018-11-03T19:56:26Z",
    "pushed_at": "2018-11-03T19:56:25Z",
    "git_url": "git://github.com/rjgupta/feed-reader-testing.git",
    "ssh_url": "git@github.com:rjgupta/feed-reader-testing.git",
    "clone_url": "https://github.com/rjgupta/feed-reader-testing.git",
    "svn_url": "https://github.com/rjgupta/feed-reader-testing",
    "homepage": null,
    "size": 43,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 181967078,
    "node_id": "MDEwOlJlcG9zaXRvcnkxODE5NjcwNzg=",
    "name": "FightClub",
    "full_name": "rjgupta/FightClub",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/FightClub",
    "description": "A 3D Fight game built in Unity 3D.",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/FightClub",
    "forks_url": "https://api.github.com/repos/rjgupta/FightClub/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/FightClub/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/FightClub/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/FightClub/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/FightClub/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/FightClub/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/FightClub/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/FightClub/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/FightClub/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/FightClub/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/FightClub/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/FightClub/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/FightClub/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/FightClub/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/FightClub/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/FightClub/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/FightClub/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/FightClub/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/FightClub/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/FightClub/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/FightClub/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/FightClub/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/FightClub/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/FightClub/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/FightClub/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/FightClub/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/FightClub/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/FightClub/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/FightClub/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/FightClub/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/FightClub/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/FightClub/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/FightClub/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/FightClub/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/FightClub/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/FightClub/deployments",
    "created_at": "2019-04-17T20:57:07Z",
    "updated_at": "2019-12-08T01:47:47Z",
    "pushed_at": "2019-05-10T21:25:40Z",
    "git_url": "git://github.com/rjgupta/FightClub.git",
    "ssh_url": "git@github.com:rjgupta/FightClub.git",
    "clone_url": "https://github.com/rjgupta/FightClub.git",
    "svn_url": "https://github.com/rjgupta/FightClub",
    "homepage": null,
    "size": 83604,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "C#",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 1,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "master"
  },
  {
    "id": 130479046,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMzA0NzkwNDY=",
    "name": "front-end-handbook-2018",
    "full_name": "rjgupta/front-end-handbook-2018",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/front-end-handbook-2018",
    "description": "2018 edition of our front-end development handbook",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018",
    "forks_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/front-end-handbook-2018/deployments",
    "created_at": "2018-04-21T14:01:17Z",
    "updated_at": "2018-04-21T14:01:19Z",
    "pushed_at": "2018-04-20T16:33:11Z",
    "git_url": "git://github.com/rjgupta/front-end-handbook-2018.git",
    "ssh_url": "git@github.com:rjgupta/front-end-handbook-2018.git",
    "clone_url": "https://github.com/rjgupta/front-end-handbook-2018.git",
    "svn_url": "https://github.com/rjgupta/front-end-handbook-2018",
    "homepage": "",
    "size": 13143,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 262137984,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNjIxMzc5ODQ=",
    "name": "fullstack-nanodegree-vm",
    "full_name": "rjgupta/fullstack-nanodegree-vm",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/fullstack-nanodegree-vm",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm",
    "forks_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/fullstack-nanodegree-vm/deployments",
    "created_at": "2020-05-07T19:16:01Z",
    "updated_at": "2020-05-07T19:16:03Z",
    "pushed_at": "2020-04-14T05:35:22Z",
    "git_url": "git://github.com/rjgupta/fullstack-nanodegree-vm.git",
    "ssh_url": "git@github.com:rjgupta/fullstack-nanodegree-vm.git",
    "clone_url": "https://github.com/rjgupta/fullstack-nanodegree-vm.git",
    "svn_url": "https://github.com/rjgupta/fullstack-nanodegree-vm",
    "homepage": null,
    "size": 1235,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 243091006,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNDMwOTEwMDY=",
    "name": "Google_WordCloud_Project",
    "full_name": "rjgupta/Google_WordCloud_Project",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/Google_WordCloud_Project",
    "description": "Google Python IT Automation Certification first project solution",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project",
    "forks_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/Google_WordCloud_Project/deployments",
    "created_at": "2020-02-25T20:02:52Z",
    "updated_at": "2020-03-05T17:28:20Z",
    "pushed_at": "2020-03-05T17:28:18Z",
    "git_url": "git://github.com/rjgupta/Google_WordCloud_Project.git",
    "ssh_url": "git@github.com:rjgupta/Google_WordCloud_Project.git",
    "clone_url": "https://github.com/rjgupta/Google_WordCloud_Project.git",
    "svn_url": "https://github.com/rjgupta/Google_WordCloud_Project",
    "homepage": null,
    "size": 67,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Jupyter Notebook",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 126998231,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjY5OTgyMzE=",
    "name": "green-screen-problem",
    "full_name": "rjgupta/green-screen-problem",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/green-screen-problem",
    "description": "An algorithm written in JS to solve Green screen problem.",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/green-screen-problem",
    "forks_url": "https://api.github.com/repos/rjgupta/green-screen-problem/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/green-screen-problem/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/green-screen-problem/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/green-screen-problem/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/green-screen-problem/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/green-screen-problem/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/green-screen-problem/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/green-screen-problem/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/green-screen-problem/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/green-screen-problem/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/green-screen-problem/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/green-screen-problem/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/green-screen-problem/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/green-screen-problem/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/green-screen-problem/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/green-screen-problem/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/green-screen-problem/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/green-screen-problem/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/green-screen-problem/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/green-screen-problem/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/green-screen-problem/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/green-screen-problem/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/green-screen-problem/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/green-screen-problem/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/green-screen-problem/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/green-screen-problem/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/green-screen-problem/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/green-screen-problem/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/green-screen-problem/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/green-screen-problem/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/green-screen-problem/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/green-screen-problem/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/green-screen-problem/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/green-screen-problem/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/green-screen-problem/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/green-screen-problem/deployments",
    "created_at": "2018-03-27T14:21:00Z",
    "updated_at": "2018-03-31T06:19:02Z",
    "pushed_at": "2018-03-31T06:19:01Z",
    "git_url": "git://github.com/rjgupta/green-screen-problem.git",
    "ssh_url": "git@github.com:rjgupta/green-screen-problem.git",
    "clone_url": "https://github.com/rjgupta/green-screen-problem.git",
    "svn_url": "https://github.com/rjgupta/green-screen-problem",
    "homepage": null,
    "size": 21,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "gpl-3.0",
      "name": "GNU General Public License v3.0",
      "spdx_id": "GPL-3.0",
      "url": "https://api.github.com/licenses/gpl-3.0",
      "node_id": "MDc6TGljZW5zZTk="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 217125624,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMTcxMjU2MjQ=",
    "name": "hello-github-actions",
    "full_name": "rjgupta/hello-github-actions",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/hello-github-actions",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/hello-github-actions",
    "forks_url": "https://api.github.com/repos/rjgupta/hello-github-actions/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/hello-github-actions/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/hello-github-actions/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/hello-github-actions/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/hello-github-actions/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/hello-github-actions/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/hello-github-actions/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/hello-github-actions/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/hello-github-actions/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/hello-github-actions/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/hello-github-actions/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/hello-github-actions/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/hello-github-actions/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/hello-github-actions/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/hello-github-actions/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/hello-github-actions/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/hello-github-actions/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/hello-github-actions/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/hello-github-actions/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/hello-github-actions/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/hello-github-actions/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/hello-github-actions/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/hello-github-actions/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/hello-github-actions/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/hello-github-actions/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/hello-github-actions/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/hello-github-actions/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/hello-github-actions/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/hello-github-actions/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/hello-github-actions/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/hello-github-actions/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/hello-github-actions/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/hello-github-actions/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/hello-github-actions/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/hello-github-actions/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/hello-github-actions/deployments",
    "created_at": "2019-10-23T18:24:35Z",
    "updated_at": "2019-10-23T18:24:40Z",
    "pushed_at": "2019-10-23T18:24:38Z",
    "git_url": "git://github.com/rjgupta/hello-github-actions.git",
    "ssh_url": "git@github.com:rjgupta/hello-github-actions.git",
    "clone_url": "https://github.com/rjgupta/hello-github-actions.git",
    "svn_url": "https://github.com/rjgupta/hello-github-actions",
    "homepage": "https://lab.github.com/github/hello-github-actions!",
    "size": 0,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 1,
    "license": null,
    "forks": 0,
    "open_issues": 1,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 130314521,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMzAzMTQ1MjE=",
    "name": "HRManager",
    "full_name": "rjgupta/HRManager",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/HRManager",
    "description": "A project for understanding the working in Servlet, JSP, Java Beans and JDBC for database Connection with MySQL",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/HRManager",
    "forks_url": "https://api.github.com/repos/rjgupta/HRManager/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/HRManager/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/HRManager/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/HRManager/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/HRManager/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/HRManager/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/HRManager/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/HRManager/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/HRManager/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/HRManager/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/HRManager/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/HRManager/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/HRManager/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/HRManager/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/HRManager/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/HRManager/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/HRManager/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/HRManager/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/HRManager/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/HRManager/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/HRManager/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/HRManager/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/HRManager/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/HRManager/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/HRManager/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/HRManager/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/HRManager/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/HRManager/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/HRManager/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/HRManager/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/HRManager/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/HRManager/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/HRManager/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/HRManager/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/HRManager/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/HRManager/deployments",
    "created_at": "2018-04-20T05:44:53Z",
    "updated_at": "2020-05-07T19:10:42Z",
    "pushed_at": "2018-04-20T05:52:19Z",
    "git_url": "git://github.com/rjgupta/HRManager.git",
    "ssh_url": "git@github.com:rjgupta/HRManager.git",
    "clone_url": "https://github.com/rjgupta/HRManager.git",
    "svn_url": "https://github.com/rjgupta/HRManager",
    "homepage": null,
    "size": 1316,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Java",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": true,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 157033216,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNTcwMzMyMTY=",
    "name": "Image-Classifier-Project",
    "full_name": "rjgupta/Image-Classifier-Project",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/Image-Classifier-Project",
    "description": "An Image Classifier command line application under the Udacity AI Programming with Python Nanodegree",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project",
    "forks_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/Image-Classifier-Project/deployments",
    "created_at": "2018-11-11T00:12:31Z",
    "updated_at": "2020-07-05T20:01:01Z",
    "pushed_at": "2020-07-05T20:00:59Z",
    "git_url": "git://github.com/rjgupta/Image-Classifier-Project.git",
    "ssh_url": "git@github.com:rjgupta/Image-Classifier-Project.git",
    "clone_url": "https://github.com/rjgupta/Image-Classifier-Project.git",
    "svn_url": "https://github.com/rjgupta/Image-Classifier-Project",
    "homepage": null,
    "size": 3442,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 249279896,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNDkyNzk4OTY=",
    "name": "it-cert-automation-practice",
    "full_name": "rjgupta/it-cert-automation-practice",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/it-cert-automation-practice",
    "description": "Google IT Automation with Python Professional Certificate - Practice files",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice",
    "forks_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/it-cert-automation-practice/deployments",
    "created_at": "2020-03-22T21:56:54Z",
    "updated_at": "2020-03-22T21:56:55Z",
    "pushed_at": "2020-03-22T22:06:52Z",
    "git_url": "git://github.com/rjgupta/it-cert-automation-practice.git",
    "ssh_url": "git@github.com:rjgupta/it-cert-automation-practice.git",
    "clone_url": "https://github.com/rjgupta/it-cert-automation-practice.git",
    "svn_url": "https://github.com/rjgupta/it-cert-automation-practice",
    "homepage": "",
    "size": 7,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "apache-2.0",
      "name": "Apache License 2.0",
      "spdx_id": "Apache-2.0",
      "url": "https://api.github.com/licenses/apache-2.0",
      "node_id": "MDc6TGljZW5zZTI="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 257450529,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTc0NTA1Mjk=",
    "name": "javascript-fix-the-scope-lab-js-apply-000",
    "full_name": "rjgupta/javascript-fix-the-scope-lab-js-apply-000",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/javascript-fix-the-scope-lab-js-apply-000",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000",
    "forks_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/javascript-fix-the-scope-lab-js-apply-000/deployments",
    "created_at": "2020-04-21T01:39:21Z",
    "updated_at": "2020-04-22T02:31:55Z",
    "pushed_at": "2020-04-22T02:31:52Z",
    "git_url": "git://github.com/rjgupta/javascript-fix-the-scope-lab-js-apply-000.git",
    "ssh_url": "git@github.com:rjgupta/javascript-fix-the-scope-lab-js-apply-000.git",
    "clone_url": "https://github.com/rjgupta/javascript-fix-the-scope-lab-js-apply-000.git",
    "svn_url": "https://github.com/rjgupta/javascript-fix-the-scope-lab-js-apply-000",
    "homepage": null,
    "size": 139,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 257439773,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTc0Mzk3NzM=",
    "name": "javascript-intro-to-functions-lab-js-apply-000",
    "full_name": "rjgupta/javascript-intro-to-functions-lab-js-apply-000",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/javascript-intro-to-functions-lab-js-apply-000",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000",
    "forks_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/javascript-intro-to-functions-lab-js-apply-000/deployments",
    "created_at": "2020-04-21T00:34:16Z",
    "updated_at": "2020-04-21T01:39:06Z",
    "pushed_at": "2020-04-21T01:39:03Z",
    "git_url": "git://github.com/rjgupta/javascript-intro-to-functions-lab-js-apply-000.git",
    "ssh_url": "git@github.com:rjgupta/javascript-intro-to-functions-lab-js-apply-000.git",
    "clone_url": "https://github.com/rjgupta/javascript-intro-to-functions-lab-js-apply-000.git",
    "svn_url": "https://github.com/rjgupta/javascript-intro-to-functions-lab-js-apply-000",
    "homepage": null,
    "size": 118,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 257438788,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTc0Mzg3ODg=",
    "name": "javascript-strings-lab-js-apply-000",
    "full_name": "rjgupta/javascript-strings-lab-js-apply-000",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/javascript-strings-lab-js-apply-000",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000",
    "forks_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/javascript-strings-lab-js-apply-000/deployments",
    "created_at": "2020-04-21T00:27:46Z",
    "updated_at": "2020-04-21T00:33:58Z",
    "pushed_at": "2020-04-21T00:33:55Z",
    "git_url": "git://github.com/rjgupta/javascript-strings-lab-js-apply-000.git",
    "ssh_url": "git@github.com:rjgupta/javascript-strings-lab-js-apply-000.git",
    "clone_url": "https://github.com/rjgupta/javascript-strings-lab-js-apply-000.git",
    "svn_url": "https://github.com/rjgupta/javascript-strings-lab-js-apply-000",
    "homepage": null,
    "size": 27,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 236520753,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMzY1MjA3NTM=",
    "name": "JavaScript30",
    "full_name": "rjgupta/JavaScript30",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/JavaScript30",
    "description": "30 Day Vanilla JS Challenge",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/JavaScript30",
    "forks_url": "https://api.github.com/repos/rjgupta/JavaScript30/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/JavaScript30/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/JavaScript30/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/JavaScript30/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/JavaScript30/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/JavaScript30/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/JavaScript30/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/JavaScript30/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/JavaScript30/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/JavaScript30/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/JavaScript30/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/JavaScript30/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/JavaScript30/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/JavaScript30/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/JavaScript30/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/JavaScript30/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/JavaScript30/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/JavaScript30/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/JavaScript30/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/JavaScript30/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/JavaScript30/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/JavaScript30/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/JavaScript30/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/JavaScript30/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/JavaScript30/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/JavaScript30/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/JavaScript30/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/JavaScript30/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/JavaScript30/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/JavaScript30/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/JavaScript30/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/JavaScript30/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/JavaScript30/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/JavaScript30/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/JavaScript30/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/JavaScript30/deployments",
    "created_at": "2020-01-27T15:20:10Z",
    "updated_at": "2020-01-27T15:20:12Z",
    "pushed_at": "2020-01-26T07:16:42Z",
    "git_url": "git://github.com/rjgupta/JavaScript30.git",
    "ssh_url": "git@github.com:rjgupta/JavaScript30.git",
    "clone_url": "https://github.com/rjgupta/JavaScript30.git",
    "svn_url": "https://github.com/rjgupta/JavaScript30",
    "homepage": "https://JavaScript30.com",
    "size": 45765,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 257770770,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTc3NzA3NzA=",
    "name": "js-beatles-loops-lab-js-apply-000",
    "full_name": "rjgupta/js-beatles-loops-lab-js-apply-000",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/js-beatles-loops-lab-js-apply-000",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000",
    "forks_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/js-beatles-loops-lab-js-apply-000/deployments",
    "created_at": "2020-04-22T02:32:13Z",
    "updated_at": "2020-04-22T02:50:29Z",
    "pushed_at": "2020-04-22T02:50:26Z",
    "git_url": "git://github.com/rjgupta/js-beatles-loops-lab-js-apply-000.git",
    "ssh_url": "git@github.com:rjgupta/js-beatles-loops-lab-js-apply-000.git",
    "clone_url": "https://github.com/rjgupta/js-beatles-loops-lab-js-apply-000.git",
    "svn_url": "https://github.com/rjgupta/js-beatles-loops-lab-js-apply-000",
    "homepage": null,
    "size": 139,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 257774260,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTc3NzQyNjA=",
    "name": "js-deli-counter-js-apply-000",
    "full_name": "rjgupta/js-deli-counter-js-apply-000",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/js-deli-counter-js-apply-000",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000",
    "forks_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/js-deli-counter-js-apply-000/deployments",
    "created_at": "2020-04-22T02:50:43Z",
    "updated_at": "2020-04-22T04:36:18Z",
    "pushed_at": "2020-04-23T17:13:07Z",
    "git_url": "git://github.com/rjgupta/js-deli-counter-js-apply-000.git",
    "ssh_url": "git@github.com:rjgupta/js-deli-counter-js-apply-000.git",
    "clone_url": "https://github.com/rjgupta/js-deli-counter-js-apply-000.git",
    "svn_url": "https://github.com/rjgupta/js-deli-counter-js-apply-000",
    "homepage": null,
    "size": 45,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 270062873,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNzAwNjI4NzM=",
    "name": "lights-out-web-app-game",
    "full_name": "rjgupta/lights-out-web-app-game",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/lights-out-web-app-game",
    "description": "A web app game built on React.js",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game",
    "forks_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/lights-out-web-app-game/deployments",
    "created_at": "2020-06-06T18:07:26Z",
    "updated_at": "2020-06-09T19:01:33Z",
    "pushed_at": "2020-06-09T19:00:24Z",
    "git_url": "git://github.com/rjgupta/lights-out-web-app-game.git",
    "ssh_url": "git@github.com:rjgupta/lights-out-web-app-game.git",
    "clone_url": "https://github.com/rjgupta/lights-out-web-app-game.git",
    "svn_url": "https://github.com/rjgupta/lights-out-web-app-game",
    "homepage": "https://rjgupta.github.io/lights-out-web-app-game/",
    "size": 313,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 128897760,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjg4OTc3NjA=",
    "name": "log-analysis-project",
    "full_name": "rjgupta/log-analysis-project",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/log-analysis-project",
    "description": "Final project of Udacity Full Stack Web Developer Nanodegree.",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/log-analysis-project",
    "forks_url": "https://api.github.com/repos/rjgupta/log-analysis-project/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/log-analysis-project/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/log-analysis-project/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/log-analysis-project/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/log-analysis-project/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/log-analysis-project/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/log-analysis-project/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/log-analysis-project/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/log-analysis-project/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/log-analysis-project/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/log-analysis-project/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/log-analysis-project/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/log-analysis-project/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/log-analysis-project/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/log-analysis-project/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/log-analysis-project/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/log-analysis-project/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/log-analysis-project/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/log-analysis-project/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/log-analysis-project/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/log-analysis-project/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/log-analysis-project/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/log-analysis-project/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/log-analysis-project/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/log-analysis-project/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/log-analysis-project/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/log-analysis-project/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/log-analysis-project/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/log-analysis-project/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/log-analysis-project/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/log-analysis-project/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/log-analysis-project/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/log-analysis-project/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/log-analysis-project/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/log-analysis-project/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/log-analysis-project/deployments",
    "created_at": "2018-04-10T08:13:50Z",
    "updated_at": "2018-04-12T08:26:26Z",
    "pushed_at": "2018-04-12T08:26:25Z",
    "git_url": "git://github.com/rjgupta/log-analysis-project.git",
    "ssh_url": "git@github.com:rjgupta/log-analysis-project.git",
    "clone_url": "https://github.com/rjgupta/log-analysis-project.git",
    "svn_url": "https://github.com/rjgupta/log-analysis-project",
    "homepage": null,
    "size": 15,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Python",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 139100742,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMzkxMDA3NDI=",
    "name": "markdown-here",
    "full_name": "rjgupta/markdown-here",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/markdown-here",
    "description": "Google Chrome, Firefox, and Thunderbird extension that lets you write email in Markdown and render it before sending.",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/markdown-here",
    "forks_url": "https://api.github.com/repos/rjgupta/markdown-here/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/markdown-here/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/markdown-here/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/markdown-here/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/markdown-here/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/markdown-here/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/markdown-here/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/markdown-here/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/markdown-here/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/markdown-here/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/markdown-here/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/markdown-here/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/markdown-here/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/markdown-here/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/markdown-here/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/markdown-here/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/markdown-here/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/markdown-here/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/markdown-here/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/markdown-here/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/markdown-here/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/markdown-here/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/markdown-here/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/markdown-here/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/markdown-here/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/markdown-here/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/markdown-here/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/markdown-here/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/markdown-here/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/markdown-here/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/markdown-here/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/markdown-here/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/markdown-here/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/markdown-here/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/markdown-here/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/markdown-here/deployments",
    "created_at": "2018-06-29T04:28:34Z",
    "updated_at": "2018-06-29T04:28:40Z",
    "pushed_at": "2018-02-28T22:14:50Z",
    "git_url": "git://github.com/rjgupta/markdown-here.git",
    "ssh_url": "git@github.com:rjgupta/markdown-here.git",
    "clone_url": "https://github.com/rjgupta/markdown-here.git",
    "svn_url": "https://github.com/rjgupta/markdown-here",
    "homepage": "http://markdown-here.com",
    "size": 16142,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 123088709,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjMwODg3MDk=",
    "name": "matrimonial-website",
    "full_name": "rjgupta/matrimonial-website",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/matrimonial-website",
    "description": "A Matrimonial website build as a college project",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/matrimonial-website",
    "forks_url": "https://api.github.com/repos/rjgupta/matrimonial-website/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/matrimonial-website/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/matrimonial-website/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/matrimonial-website/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/matrimonial-website/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/matrimonial-website/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/matrimonial-website/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/matrimonial-website/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/matrimonial-website/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/matrimonial-website/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/matrimonial-website/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/matrimonial-website/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/matrimonial-website/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/matrimonial-website/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/matrimonial-website/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/matrimonial-website/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/matrimonial-website/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/matrimonial-website/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/matrimonial-website/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/matrimonial-website/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/matrimonial-website/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/matrimonial-website/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/matrimonial-website/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/matrimonial-website/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/matrimonial-website/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/matrimonial-website/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/matrimonial-website/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/matrimonial-website/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/matrimonial-website/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/matrimonial-website/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/matrimonial-website/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/matrimonial-website/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/matrimonial-website/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/matrimonial-website/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/matrimonial-website/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/matrimonial-website/deployments",
    "created_at": "2018-02-27T07:12:48Z",
    "updated_at": "2018-02-27T07:44:56Z",
    "pushed_at": "2018-02-27T07:43:35Z",
    "git_url": "git://github.com/rjgupta/matrimonial-website.git",
    "ssh_url": "git@github.com:rjgupta/matrimonial-website.git",
    "clone_url": "https://github.com/rjgupta/matrimonial-website.git",
    "svn_url": "https://github.com/rjgupta/matrimonial-website",
    "homepage": "",
    "size": 1384,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "ASP",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 154073621,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNTQwNzM2MjE=",
    "name": "memory-game",
    "full_name": "rjgupta/memory-game",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/memory-game",
    "description": "The Memory Game Project is a complete browser-based card matching game. But this isn’t just any memory game! It’s a shnazzy, well-designed, feature-packed memory game!",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/memory-game",
    "forks_url": "https://api.github.com/repos/rjgupta/memory-game/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/memory-game/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/memory-game/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/memory-game/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/memory-game/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/memory-game/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/memory-game/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/memory-game/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/memory-game/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/memory-game/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/memory-game/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/memory-game/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/memory-game/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/memory-game/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/memory-game/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/memory-game/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/memory-game/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/memory-game/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/memory-game/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/memory-game/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/memory-game/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/memory-game/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/memory-game/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/memory-game/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/memory-game/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/memory-game/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/memory-game/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/memory-game/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/memory-game/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/memory-game/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/memory-game/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/memory-game/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/memory-game/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/memory-game/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/memory-game/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/memory-game/deployments",
    "created_at": "2018-10-22T01:56:16Z",
    "updated_at": "2020-05-07T18:58:35Z",
    "pushed_at": "2020-05-07T18:58:32Z",
    "git_url": "git://github.com/rjgupta/memory-game.git",
    "ssh_url": "git@github.com:rjgupta/memory-game.git",
    "clone_url": "https://github.com/rjgupta/memory-game.git",
    "svn_url": "https://github.com/rjgupta/memory-game",
    "homepage": "https://rjgupta.github.io/memory-game/",
    "size": 457,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "CSS",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 1,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 121480187,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjE0ODAxODc=",
    "name": "mini-projects",
    "full_name": "rjgupta/mini-projects",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/mini-projects",
    "description": "Mini Projects written in different languages to showcase programming skills.",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/mini-projects",
    "forks_url": "https://api.github.com/repos/rjgupta/mini-projects/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/mini-projects/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/mini-projects/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/mini-projects/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/mini-projects/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/mini-projects/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/mini-projects/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/mini-projects/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/mini-projects/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/mini-projects/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/mini-projects/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/mini-projects/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/mini-projects/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/mini-projects/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/mini-projects/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/mini-projects/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/mini-projects/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/mini-projects/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/mini-projects/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/mini-projects/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/mini-projects/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/mini-projects/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/mini-projects/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/mini-projects/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/mini-projects/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/mini-projects/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/mini-projects/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/mini-projects/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/mini-projects/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/mini-projects/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/mini-projects/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/mini-projects/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/mini-projects/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/mini-projects/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/mini-projects/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/mini-projects/deployments",
    "created_at": "2018-02-14T06:50:49Z",
    "updated_at": "2020-05-07T19:08:56Z",
    "pushed_at": "2018-07-09T03:33:09Z",
    "git_url": "git://github.com/rjgupta/mini-projects.git",
    "ssh_url": "git@github.com:rjgupta/mini-projects.git",
    "clone_url": "https://github.com/rjgupta/mini-projects.git",
    "svn_url": "https://github.com/rjgupta/mini-projects",
    "homepage": "",
    "size": 6454,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Python",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": true,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "gpl-3.0",
      "name": "GNU General Public License v3.0",
      "spdx_id": "GPL-3.0",
      "url": "https://api.github.com/licenses/gpl-3.0",
      "node_id": "MDc6TGljZW5zZTk="
    },
    "forks": 1,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 157262681,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNTcyNjI2ODE=",
    "name": "Neighborhood-Map",
    "full_name": "rjgupta/Neighborhood-Map",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/Neighborhood-Map",
    "description": "A single-page application using React featuring a map of a neighborhood.",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/Neighborhood-Map",
    "forks_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/Neighborhood-Map/deployments",
    "created_at": "2018-11-12T19:09:02Z",
    "updated_at": "2018-11-20T23:24:04Z",
    "pushed_at": "2018-11-20T23:24:02Z",
    "git_url": "git://github.com/rjgupta/Neighborhood-Map.git",
    "ssh_url": "git@github.com:rjgupta/Neighborhood-Map.git",
    "clone_url": "https://github.com/rjgupta/Neighborhood-Map.git",
    "svn_url": "https://github.com/rjgupta/Neighborhood-Map",
    "homepage": null,
    "size": 105,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 217125580,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMTcxMjU1ODA=",
    "name": "node-express-course",
    "full_name": "rjgupta/node-express-course",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/node-express-course",
    "description": "An introduction to Node.js and Express.js servers",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/node-express-course",
    "forks_url": "https://api.github.com/repos/rjgupta/node-express-course/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/node-express-course/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/node-express-course/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/node-express-course/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/node-express-course/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/node-express-course/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/node-express-course/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/node-express-course/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/node-express-course/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/node-express-course/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/node-express-course/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/node-express-course/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/node-express-course/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/node-express-course/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/node-express-course/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/node-express-course/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/node-express-course/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/node-express-course/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/node-express-course/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/node-express-course/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/node-express-course/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/node-express-course/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/node-express-course/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/node-express-course/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/node-express-course/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/node-express-course/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/node-express-course/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/node-express-course/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/node-express-course/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/node-express-course/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/node-express-course/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/node-express-course/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/node-express-course/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/node-express-course/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/node-express-course/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/node-express-course/deployments",
    "created_at": "2019-10-23T18:24:16Z",
    "updated_at": "2019-10-23T18:24:24Z",
    "pushed_at": "2019-10-23T18:24:20Z",
    "git_url": "git://github.com/rjgupta/node-express-course.git",
    "ssh_url": "git@github.com:rjgupta/node-express-course.git",
    "clone_url": "https://github.com/rjgupta/node-express-course.git",
    "svn_url": "https://github.com/rjgupta/node-express-course",
    "homepage": "https://lab.github.com/everydeveloper/introduction-to-node-with-express",
    "size": 149,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 1,
    "license": null,
    "forks": 0,
    "open_issues": 1,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 129849849,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjk4NDk4NDk=",
    "name": "OCAJP-Exam-Preparation",
    "full_name": "rjgupta/OCAJP-Exam-Preparation",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/OCAJP-Exam-Preparation",
    "description": "Practice for OCA Oracle Certified Associate Java SE 8 Programmer Exam 1Z0 808 (OCAJP)",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation",
    "forks_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/OCAJP-Exam-Preparation/deployments",
    "created_at": "2018-04-17T05:16:30Z",
    "updated_at": "2020-05-07T19:09:55Z",
    "pushed_at": "2018-05-17T13:56:17Z",
    "git_url": "git://github.com/rjgupta/OCAJP-Exam-Preparation.git",
    "ssh_url": "git@github.com:rjgupta/OCAJP-Exam-Preparation.git",
    "clone_url": "https://github.com/rjgupta/OCAJP-Exam-Preparation.git",
    "svn_url": "https://github.com/rjgupta/OCAJP-Exam-Preparation",
    "homepage": null,
    "size": 70,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Java",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": true,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 1,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 137321208,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMzczMjEyMDg=",
    "name": "PageLoadingEffects",
    "full_name": "rjgupta/PageLoadingEffects",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/PageLoadingEffects",
    "description": "Modern ways of revealing new content using SVG animations.",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/PageLoadingEffects",
    "forks_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/PageLoadingEffects/deployments",
    "created_at": "2018-06-14T07:18:16Z",
    "updated_at": "2018-06-14T07:18:17Z",
    "pushed_at": "2014-04-23T08:08:18Z",
    "git_url": "git://github.com/rjgupta/PageLoadingEffects.git",
    "ssh_url": "git@github.com:rjgupta/PageLoadingEffects.git",
    "clone_url": "https://github.com/rjgupta/PageLoadingEffects.git",
    "svn_url": "https://github.com/rjgupta/PageLoadingEffects",
    "homepage": null,
    "size": 175,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "HTML",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 137073376,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMzcwNzMzNzY=",
    "name": "particles.js",
    "full_name": "rjgupta/particles.js",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/particles.js",
    "description": "A lightweight JavaScript library for creating particles",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/particles.js",
    "forks_url": "https://api.github.com/repos/rjgupta/particles.js/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/particles.js/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/particles.js/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/particles.js/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/particles.js/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/particles.js/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/particles.js/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/particles.js/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/particles.js/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/particles.js/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/particles.js/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/particles.js/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/particles.js/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/particles.js/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/particles.js/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/particles.js/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/particles.js/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/particles.js/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/particles.js/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/particles.js/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/particles.js/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/particles.js/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/particles.js/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/particles.js/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/particles.js/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/particles.js/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/particles.js/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/particles.js/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/particles.js/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/particles.js/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/particles.js/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/particles.js/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/particles.js/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/particles.js/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/particles.js/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/particles.js/deployments",
    "created_at": "2018-06-12T13:09:59Z",
    "updated_at": "2018-06-12T13:10:01Z",
    "pushed_at": "2018-04-18T04:33:22Z",
    "git_url": "git://github.com/rjgupta/particles.js.git",
    "ssh_url": "git@github.com:rjgupta/particles.js.git",
    "clone_url": "https://github.com/rjgupta/particles.js.git",
    "svn_url": "https://github.com/rjgupta/particles.js",
    "homepage": "https://vincentgarreau.com/particles.js/",
    "size": 158,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 137448891,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMzc0NDg4OTE=",
    "name": "Pixel-Art-Maker",
    "full_name": "rjgupta/Pixel-Art-Maker",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/Pixel-Art-Maker",
    "description": "A Udacity lab work to create an online Pixel Art Maker with JavaScript",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker",
    "forks_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/Pixel-Art-Maker/deployments",
    "created_at": "2018-06-15T06:21:58Z",
    "updated_at": "2020-06-10T21:28:44Z",
    "pushed_at": "2018-06-19T07:45:13Z",
    "git_url": "git://github.com/rjgupta/Pixel-Art-Maker.git",
    "ssh_url": "git@github.com:rjgupta/Pixel-Art-Maker.git",
    "clone_url": "https://github.com/rjgupta/Pixel-Art-Maker.git",
    "svn_url": "https://github.com/rjgupta/Pixel-Art-Maker",
    "homepage": "https://rjgupta.github.io/Pixel-Art-Maker/",
    "size": 399,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 140611651,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDA2MTE2NTE=",
    "name": "pokedex",
    "full_name": "rjgupta/pokedex",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/pokedex",
    "description": "more than you ever wanted to know about Pokémon",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/pokedex",
    "forks_url": "https://api.github.com/repos/rjgupta/pokedex/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/pokedex/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/pokedex/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/pokedex/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/pokedex/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/pokedex/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/pokedex/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/pokedex/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/pokedex/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/pokedex/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/pokedex/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/pokedex/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/pokedex/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/pokedex/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/pokedex/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/pokedex/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/pokedex/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/pokedex/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/pokedex/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/pokedex/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/pokedex/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/pokedex/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/pokedex/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/pokedex/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/pokedex/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/pokedex/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/pokedex/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/pokedex/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/pokedex/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/pokedex/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/pokedex/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/pokedex/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/pokedex/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/pokedex/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/pokedex/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/pokedex/deployments",
    "created_at": "2018-07-11T18:02:06Z",
    "updated_at": "2018-07-11T18:02:09Z",
    "pushed_at": "2018-07-04T21:25:29Z",
    "git_url": "git://github.com/rjgupta/pokedex.git",
    "ssh_url": "git@github.com:rjgupta/pokedex.git",
    "clone_url": "https://github.com/rjgupta/pokedex.git",
    "svn_url": "https://github.com/rjgupta/pokedex",
    "homepage": "",
    "size": 17076,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Python",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 125519301,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjU1MTkzMDE=",
    "name": "portfolio_mockup",
    "full_name": "rjgupta/portfolio_mockup",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/portfolio_mockup",
    "description": "A Portfolio mockup page for showcasing my all the profiles on Social Media.",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/portfolio_mockup",
    "forks_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/portfolio_mockup/deployments",
    "created_at": "2018-03-16T13:22:51Z",
    "updated_at": "2020-05-07T19:06:10Z",
    "pushed_at": "2018-03-16T13:38:48Z",
    "git_url": "git://github.com/rjgupta/portfolio_mockup.git",
    "ssh_url": "git@github.com:rjgupta/portfolio_mockup.git",
    "clone_url": "https://github.com/rjgupta/portfolio_mockup.git",
    "svn_url": "https://github.com/rjgupta/portfolio_mockup",
    "homepage": "",
    "size": 6241,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "CSS",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 0,
    "mirror_url": null,
    "archived": true,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "gpl-3.0",
      "name": "GNU General Public License v3.0",
      "spdx_id": "GPL-3.0",
      "url": "https://api.github.com/licenses/gpl-3.0",
      "node_id": "MDc6TGljZW5zZTk="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 241432327,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNDE0MzIzMjc=",
    "name": "Python_price_tracker",
    "full_name": "rjgupta/Python_price_tracker",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/Python_price_tracker",
    "description": "A price tracker script to fetch product price and receive an email when the price falls.",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/Python_price_tracker",
    "forks_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/Python_price_tracker/deployments",
    "created_at": "2020-02-18T18:07:44Z",
    "updated_at": "2020-02-18T19:05:19Z",
    "pushed_at": "2020-02-18T19:05:17Z",
    "git_url": "git://github.com/rjgupta/Python_price_tracker.git",
    "ssh_url": "git@github.com:rjgupta/Python_price_tracker.git",
    "clone_url": "https://github.com/rjgupta/Python_price_tracker.git",
    "svn_url": "https://github.com/rjgupta/Python_price_tracker",
    "homepage": null,
    "size": 1,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Python",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 174231687,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNzQyMzE2ODc=",
    "name": "Race-Time",
    "full_name": "rjgupta/Race-Time",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/Race-Time",
    "description": "Classic 2D Racing game built on Unity 3D for Android.",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/Race-Time",
    "forks_url": "https://api.github.com/repos/rjgupta/Race-Time/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/Race-Time/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/Race-Time/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/Race-Time/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/Race-Time/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/Race-Time/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/Race-Time/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/Race-Time/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/Race-Time/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/Race-Time/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/Race-Time/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/Race-Time/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/Race-Time/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/Race-Time/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/Race-Time/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/Race-Time/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/Race-Time/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/Race-Time/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/Race-Time/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/Race-Time/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/Race-Time/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/Race-Time/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/Race-Time/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/Race-Time/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/Race-Time/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/Race-Time/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/Race-Time/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/Race-Time/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/Race-Time/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/Race-Time/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/Race-Time/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/Race-Time/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/Race-Time/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/Race-Time/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/Race-Time/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/Race-Time/deployments",
    "created_at": "2019-03-06T22:36:01Z",
    "updated_at": "2019-04-17T21:23:33Z",
    "pushed_at": "2019-03-26T23:49:57Z",
    "git_url": "git://github.com/rjgupta/Race-Time.git",
    "ssh_url": "git@github.com:rjgupta/Race-Time.git",
    "clone_url": "https://github.com/rjgupta/Race-Time.git",
    "svn_url": "https://github.com/rjgupta/Race-Time",
    "homepage": "",
    "size": 94966,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "C#",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 1,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 127316200,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjczMTYyMDA=",
    "name": "rajatgupta",
    "full_name": "rjgupta/rajatgupta",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/rajatgupta",
    "description": "Personal portfolio website.",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/rajatgupta",
    "forks_url": "https://api.github.com/repos/rjgupta/rajatgupta/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/rajatgupta/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/rajatgupta/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/rajatgupta/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/rajatgupta/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/rajatgupta/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/rajatgupta/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/rajatgupta/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/rajatgupta/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/rajatgupta/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/rajatgupta/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/rajatgupta/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/rajatgupta/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/rajatgupta/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/rajatgupta/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/rajatgupta/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/rajatgupta/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/rajatgupta/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/rajatgupta/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/rajatgupta/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/rajatgupta/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/rajatgupta/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/rajatgupta/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/rajatgupta/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/rajatgupta/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/rajatgupta/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/rajatgupta/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/rajatgupta/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/rajatgupta/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/rajatgupta/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/rajatgupta/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/rajatgupta/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/rajatgupta/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/rajatgupta/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/rajatgupta/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/rajatgupta/deployments",
    "created_at": "2018-03-29T16:10:26Z",
    "updated_at": "2018-12-03T16:22:23Z",
    "pushed_at": "2018-06-20T04:28:53Z",
    "git_url": "git://github.com/rjgupta/rajatgupta.git",
    "ssh_url": "git@github.com:rjgupta/rajatgupta.git",
    "clone_url": "https://github.com/rjgupta/rajatgupta.git",
    "svn_url": "https://github.com/rjgupta/rajatgupta",
    "homepage": "https://imrajatgupta.github.io/rajatgupta/",
    "size": 18272,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "gpl-3.0",
      "name": "GNU General Public License v3.0",
      "spdx_id": "GPL-3.0",
      "url": "https://api.github.com/licenses/gpl-3.0",
      "node_id": "MDc6TGljZW5zZTk="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 278722555,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNzg3MjI1NTU=",
    "name": "react-ecommerce-website",
    "full_name": "rjgupta/react-ecommerce-website",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/react-ecommerce-website",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/react-ecommerce-website",
    "forks_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/react-ecommerce-website/deployments",
    "created_at": "2020-07-10T19:59:48Z",
    "updated_at": "2020-07-14T21:52:01Z",
    "pushed_at": "2020-07-14T21:51:36Z",
    "git_url": "git://github.com/rjgupta/react-ecommerce-website.git",
    "ssh_url": "git@github.com:rjgupta/react-ecommerce-website.git",
    "clone_url": "https://github.com/rjgupta/react-ecommerce-website.git",
    "svn_url": "https://github.com/rjgupta/react-ecommerce-website",
    "homepage": null,
    "size": 467,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 279962373,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNzk5NjIzNzM=",
    "name": "react-github-search-users",
    "full_name": "rjgupta/react-github-search-users",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/react-github-search-users",
    "description": "A React web app for searching GitHub users. ",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/react-github-search-users",
    "forks_url": "https://api.github.com/repos/rjgupta/react-github-search-users/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/react-github-search-users/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/react-github-search-users/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/react-github-search-users/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/react-github-search-users/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/react-github-search-users/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/react-github-search-users/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/react-github-search-users/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/react-github-search-users/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/react-github-search-users/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/react-github-search-users/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/react-github-search-users/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/react-github-search-users/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/react-github-search-users/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/react-github-search-users/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/react-github-search-users/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/react-github-search-users/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/react-github-search-users/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/react-github-search-users/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/react-github-search-users/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/react-github-search-users/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/react-github-search-users/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/react-github-search-users/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/react-github-search-users/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/react-github-search-users/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/react-github-search-users/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/react-github-search-users/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/react-github-search-users/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/react-github-search-users/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/react-github-search-users/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/react-github-search-users/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/react-github-search-users/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/react-github-search-users/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/react-github-search-users/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/react-github-search-users/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/react-github-search-users/deployments",
    "created_at": "2020-07-15T19:46:59Z",
    "updated_at": "2020-07-15T19:46:59Z",
    "pushed_at": "2020-07-15T19:47:00Z",
    "git_url": "git://github.com/rjgupta/react-github-search-users.git",
    "ssh_url": "git@github.com:rjgupta/react-github-search-users.git",
    "clone_url": "https://github.com/rjgupta/react-github-search-users.git",
    "svn_url": "https://github.com/rjgupta/react-github-search-users",
    "homepage": null,
    "size": 0,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 150302325,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNTAzMDIzMjU=",
    "name": "reactnd-contacts-complete",
    "full_name": "rjgupta/reactnd-contacts-complete",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/reactnd-contacts-complete",
    "description": "Code-along project for the Contacts app",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete",
    "forks_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/reactnd-contacts-complete/deployments",
    "created_at": "2018-09-25T17:16:07Z",
    "updated_at": "2018-09-25T17:16:09Z",
    "pushed_at": "2018-07-31T16:20:47Z",
    "git_url": "git://github.com/rjgupta/reactnd-contacts-complete.git",
    "ssh_url": "git@github.com:rjgupta/reactnd-contacts-complete.git",
    "clone_url": "https://github.com/rjgupta/reactnd-contacts-complete.git",
    "svn_url": "https://github.com/rjgupta/reactnd-contacts-complete",
    "homepage": "https://www.udacity.com/course/react-nanodegree--nd019",
    "size": 127,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 156020590,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNTYwMjA1OTA=",
    "name": "Restaurant-Reviews-App-Stage1",
    "full_name": "rjgupta/Restaurant-Reviews-App-Stage1",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/Restaurant-Reviews-App-Stage1",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1",
    "forks_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/Restaurant-Reviews-App-Stage1/deployments",
    "created_at": "2018-11-03T20:19:30Z",
    "updated_at": "2018-11-12T21:02:45Z",
    "pushed_at": "2018-11-12T21:02:44Z",
    "git_url": "git://github.com/rjgupta/Restaurant-Reviews-App-Stage1.git",
    "ssh_url": "git@github.com:rjgupta/Restaurant-Reviews-App-Stage1.git",
    "clone_url": "https://github.com/rjgupta/Restaurant-Reviews-App-Stage1.git",
    "svn_url": "https://github.com/rjgupta/Restaurant-Reviews-App-Stage1",
    "homepage": null,
    "size": 1108,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 177885605,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNzc4ODU2MDU=",
    "name": "Resume",
    "full_name": "rjgupta/Resume",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/Resume",
    "description": "Most recent Resume of Rajat Gupta",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/Resume",
    "forks_url": "https://api.github.com/repos/rjgupta/Resume/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/Resume/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/Resume/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/Resume/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/Resume/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/Resume/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/Resume/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/Resume/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/Resume/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/Resume/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/Resume/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/Resume/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/Resume/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/Resume/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/Resume/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/Resume/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/Resume/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/Resume/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/Resume/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/Resume/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/Resume/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/Resume/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/Resume/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/Resume/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/Resume/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/Resume/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/Resume/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/Resume/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/Resume/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/Resume/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/Resume/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/Resume/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/Resume/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/Resume/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/Resume/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/Resume/deployments",
    "created_at": "2019-03-26T23:46:14Z",
    "updated_at": "2020-07-14T21:56:30Z",
    "pushed_at": "2020-07-14T21:56:28Z",
    "git_url": "git://github.com/rjgupta/Resume.git",
    "ssh_url": "git@github.com:rjgupta/Resume.git",
    "clone_url": "https://github.com/rjgupta/Resume.git",
    "svn_url": "https://github.com/rjgupta/Resume",
    "homepage": null,
    "size": 966,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 262430457,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNjI0MzA0NTc=",
    "name": "rj-social-launcher",
    "full_name": "rjgupta/rj-social-launcher",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/rj-social-launcher",
    "description": "Hi! I'm an extension built to lead YOU to all the social accounts of a person. Please clone me!!! Pretty please?",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/rj-social-launcher",
    "forks_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/rj-social-launcher/deployments",
    "created_at": "2020-05-08T21:16:43Z",
    "updated_at": "2020-05-08T21:19:28Z",
    "pushed_at": "2020-05-08T21:18:50Z",
    "git_url": "git://github.com/rjgupta/rj-social-launcher.git",
    "ssh_url": "git@github.com:rjgupta/rj-social-launcher.git",
    "clone_url": "https://github.com/rjgupta/rj-social-launcher.git",
    "svn_url": "https://github.com/rjgupta/rj-social-launcher",
    "homepage": null,
    "size": 27,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 181584898,
    "node_id": "MDEwOlJlcG9zaXRvcnkxODE1ODQ4OTg=",
    "name": "rjgupta",
    "full_name": "rjgupta/rjgupta",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/rjgupta",
    "description": "Portfolio website",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/rjgupta",
    "forks_url": "https://api.github.com/repos/rjgupta/rjgupta/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/rjgupta/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/rjgupta/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/rjgupta/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/rjgupta/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/rjgupta/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/rjgupta/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/rjgupta/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/rjgupta/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/rjgupta/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/rjgupta/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/rjgupta/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/rjgupta/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/rjgupta/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/rjgupta/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/rjgupta/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/rjgupta/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/rjgupta/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/rjgupta/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/rjgupta/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/rjgupta/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/rjgupta/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/rjgupta/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/rjgupta/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/rjgupta/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/rjgupta/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/rjgupta/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/rjgupta/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/rjgupta/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/rjgupta/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/rjgupta/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/rjgupta/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/rjgupta/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/rjgupta/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/rjgupta/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/rjgupta/deployments",
    "created_at": "2019-04-16T00:25:41Z",
    "updated_at": "2020-07-04T19:43:17Z",
    "pushed_at": "2020-07-04T19:44:40Z",
    "git_url": "git://github.com/rjgupta/rjgupta.git",
    "ssh_url": "git@github.com:rjgupta/rjgupta.git",
    "clone_url": "https://github.com/rjgupta/rjgupta.git",
    "svn_url": "https://github.com/rjgupta/rjgupta",
    "homepage": "",
    "size": 25561,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": true,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 260521053,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNjA1MjEwNTM=",
    "name": "Spotify_playlist_generator",
    "full_name": "rjgupta/Spotify_playlist_generator",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/Spotify_playlist_generator",
    "description": "An automated Spotify playlist generator from YouTube videos using Spotify and YouTube APIs",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator",
    "forks_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/Spotify_playlist_generator/deployments",
    "created_at": "2020-05-01T17:43:08Z",
    "updated_at": "2020-05-12T02:34:03Z",
    "pushed_at": "2020-05-01T17:51:33Z",
    "git_url": "git://github.com/rjgupta/Spotify_playlist_generator.git",
    "ssh_url": "git@github.com:rjgupta/Spotify_playlist_generator.git",
    "clone_url": "https://github.com/rjgupta/Spotify_playlist_generator.git",
    "svn_url": "https://github.com/rjgupta/Spotify_playlist_generator",
    "homepage": "",
    "size": 0,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "Python",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "master"
  },
  {
    "id": 244967167,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNDQ5NjcxNjc=",
    "name": "startbootstrap-resume",
    "full_name": "rjgupta/startbootstrap-resume",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/startbootstrap-resume",
    "description": "A Bootstrap 4 resume/CV theme created by Start Bootstrap",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/startbootstrap-resume",
    "forks_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/startbootstrap-resume/deployments",
    "created_at": "2020-03-04T17:52:16Z",
    "updated_at": "2020-06-17T21:12:24Z",
    "pushed_at": "2020-03-02T20:30:43Z",
    "git_url": "git://github.com/rjgupta/startbootstrap-resume.git",
    "ssh_url": "git@github.com:rjgupta/startbootstrap-resume.git",
    "clone_url": "https://github.com/rjgupta/startbootstrap-resume.git",
    "svn_url": "https://github.com/rjgupta/startbootstrap-resume",
    "homepage": "https://startbootstrap.com/template-overviews/resume/",
    "size": 15632,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 140227260,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDAyMjcyNjA=",
    "name": "Statistics-From-Stock-Data",
    "full_name": "rjgupta/Statistics-From-Stock-Data",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/Statistics-From-Stock-Data",
    "description": "A Jupyter Notebook to get insights on Google, Apple and Amazon's Stock Data through Pandas",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data",
    "forks_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/Statistics-From-Stock-Data/deployments",
    "created_at": "2018-07-09T03:34:54Z",
    "updated_at": "2018-07-11T06:38:52Z",
    "pushed_at": "2018-07-11T06:38:51Z",
    "git_url": "git://github.com/rjgupta/Statistics-From-Stock-Data.git",
    "ssh_url": "git@github.com:rjgupta/Statistics-From-Stock-Data.git",
    "clone_url": "https://github.com/rjgupta/Statistics-From-Stock-Data.git",
    "svn_url": "https://github.com/rjgupta/Statistics-From-Stock-Data",
    "homepage": null,
    "size": 358,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 1,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 137733755,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMzc3MzM3NTU=",
    "name": "tasklist",
    "full_name": "rjgupta/tasklist",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/tasklist",
    "description": "A javascript based web app for creating tasks",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/tasklist",
    "forks_url": "https://api.github.com/repos/rjgupta/tasklist/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/tasklist/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/tasklist/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/tasklist/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/tasklist/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/tasklist/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/tasklist/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/tasklist/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/tasklist/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/tasklist/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/tasklist/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/tasklist/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/tasklist/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/tasklist/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/tasklist/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/tasklist/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/tasklist/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/tasklist/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/tasklist/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/tasklist/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/tasklist/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/tasklist/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/tasklist/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/tasklist/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/tasklist/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/tasklist/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/tasklist/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/tasklist/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/tasklist/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/tasklist/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/tasklist/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/tasklist/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/tasklist/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/tasklist/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/tasklist/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/tasklist/deployments",
    "created_at": "2018-06-18T09:35:42Z",
    "updated_at": "2018-06-18T09:40:11Z",
    "pushed_at": "2018-06-18T09:40:10Z",
    "git_url": "git://github.com/rjgupta/tasklist.git",
    "ssh_url": "git@github.com:rjgupta/tasklist.git",
    "clone_url": "https://github.com/rjgupta/tasklist.git",
    "svn_url": "https://github.com/rjgupta/tasklist",
    "homepage": null,
    "size": 2,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 262138266,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNjIxMzgyNjY=",
    "name": "tech-interview-handbook",
    "full_name": "rjgupta/tech-interview-handbook",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/tech-interview-handbook",
    "description": "💯 Materials to help you rock your next coding interview",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/tech-interview-handbook",
    "forks_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/tech-interview-handbook/deployments",
    "created_at": "2020-05-07T19:17:29Z",
    "updated_at": "2020-05-07T19:17:32Z",
    "pushed_at": "2020-05-06T03:36:56Z",
    "git_url": "git://github.com/rjgupta/tech-interview-handbook.git",
    "ssh_url": "git@github.com:rjgupta/tech-interview-handbook.git",
    "clone_url": "https://github.com/rjgupta/tech-interview-handbook.git",
    "svn_url": "https://github.com/rjgupta/tech-interview-handbook",
    "homepage": "https://yangshun.github.io/tech-interview-handbook/",
    "size": 7018,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 125733798,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjU3MzM3OTg=",
    "name": "tip-calculator",
    "full_name": "rjgupta/tip-calculator",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/tip-calculator",
    "description": "A Tip Calculator web page with JavaScript.",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/tip-calculator",
    "forks_url": "https://api.github.com/repos/rjgupta/tip-calculator/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/tip-calculator/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/tip-calculator/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/tip-calculator/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/tip-calculator/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/tip-calculator/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/tip-calculator/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/tip-calculator/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/tip-calculator/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/tip-calculator/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/tip-calculator/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/tip-calculator/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/tip-calculator/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/tip-calculator/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/tip-calculator/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/tip-calculator/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/tip-calculator/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/tip-calculator/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/tip-calculator/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/tip-calculator/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/tip-calculator/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/tip-calculator/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/tip-calculator/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/tip-calculator/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/tip-calculator/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/tip-calculator/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/tip-calculator/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/tip-calculator/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/tip-calculator/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/tip-calculator/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/tip-calculator/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/tip-calculator/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/tip-calculator/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/tip-calculator/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/tip-calculator/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/tip-calculator/deployments",
    "created_at": "2018-03-18T14:34:08Z",
    "updated_at": "2020-05-07T18:55:45Z",
    "pushed_at": "2018-06-17T13:33:05Z",
    "git_url": "git://github.com/rjgupta/tip-calculator.git",
    "ssh_url": "git@github.com:rjgupta/tip-calculator.git",
    "clone_url": "https://github.com/rjgupta/tip-calculator.git",
    "svn_url": "https://github.com/rjgupta/tip-calculator",
    "homepage": "https://rjgupta.github.io/tip-calculator/",
    "size": 137,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "gpl-3.0",
      "name": "GNU General Public License v3.0",
      "spdx_id": "GPL-3.0",
      "url": "https://api.github.com/licenses/gpl-3.0",
      "node_id": "MDc6TGljZW5zZTk="
    },
    "forks": 1,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 122018865,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjIwMTg4NjU=",
    "name": "ud036_StarterCode",
    "full_name": "rjgupta/ud036_StarterCode",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/ud036_StarterCode",
    "description": "Starter Code",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/ud036_StarterCode",
    "forks_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/ud036_StarterCode/deployments",
    "created_at": "2018-02-19T04:27:06Z",
    "updated_at": "2018-02-19T04:27:07Z",
    "pushed_at": "2018-02-22T07:46:35Z",
    "git_url": "git://github.com/rjgupta/ud036_StarterCode.git",
    "ssh_url": "git@github.com:rjgupta/ud036_StarterCode.git",
    "clone_url": "https://github.com/rjgupta/ud036_StarterCode.git",
    "svn_url": "https://github.com/rjgupta/ud036_StarterCode",
    "homepage": null,
    "size": 13,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Python",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 148200942,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDgyMDA5NDI=",
    "name": "ud891",
    "full_name": "rjgupta/ud891",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/ud891",
    "description": "Google and Udacity course on Accessibility.",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/ud891",
    "forks_url": "https://api.github.com/repos/rjgupta/ud891/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/ud891/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/ud891/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/ud891/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/ud891/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/ud891/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/ud891/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/ud891/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/ud891/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/ud891/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/ud891/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/ud891/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/ud891/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/ud891/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/ud891/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/ud891/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/ud891/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/ud891/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/ud891/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/ud891/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/ud891/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/ud891/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/ud891/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/ud891/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/ud891/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/ud891/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/ud891/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/ud891/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/ud891/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/ud891/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/ud891/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/ud891/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/ud891/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/ud891/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/ud891/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/ud891/deployments",
    "created_at": "2018-09-10T18:30:37Z",
    "updated_at": "2018-09-10T18:30:40Z",
    "pushed_at": "2018-09-06T23:50:19Z",
    "git_url": "git://github.com/rjgupta/ud891.git",
    "ssh_url": "git@github.com:rjgupta/ud891.git",
    "clone_url": "https://github.com/rjgupta/ud891.git",
    "svn_url": "https://github.com/rjgupta/ud891",
    "homepage": null,
    "size": 17458,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "gh-pages"
  },
  {
    "id": 177210131,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNzcyMTAxMzE=",
    "name": "Weather-Web",
    "full_name": "rjgupta/Weather-Web",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/Weather-Web",
    "description": "An iOS Weather app usinng Cocoapods, GPS, APIs and REST to fetch data from the web.",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/Weather-Web",
    "forks_url": "https://api.github.com/repos/rjgupta/Weather-Web/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/Weather-Web/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/Weather-Web/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/Weather-Web/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/Weather-Web/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/Weather-Web/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/Weather-Web/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/Weather-Web/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/Weather-Web/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/Weather-Web/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/Weather-Web/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/Weather-Web/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/Weather-Web/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/Weather-Web/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/Weather-Web/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/Weather-Web/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/Weather-Web/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/Weather-Web/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/Weather-Web/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/Weather-Web/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/Weather-Web/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/Weather-Web/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/Weather-Web/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/Weather-Web/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/Weather-Web/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/Weather-Web/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/Weather-Web/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/Weather-Web/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/Weather-Web/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/Weather-Web/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/Weather-Web/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/Weather-Web/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/Weather-Web/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/Weather-Web/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/Weather-Web/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/Weather-Web/deployments",
    "created_at": "2019-03-22T21:15:03Z",
    "updated_at": "2019-04-17T21:22:05Z",
    "pushed_at": "2019-04-04T21:21:16Z",
    "git_url": "git://github.com/rjgupta/Weather-Web.git",
    "ssh_url": "git@github.com:rjgupta/Weather-Web.git",
    "clone_url": "https://github.com/rjgupta/Weather-Web.git",
    "svn_url": "https://github.com/rjgupta/Weather-Web",
    "homepage": null,
    "size": 2208,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Swift",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 247765909,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNDc3NjU5MDk=",
    "name": "webpack-demo-app",
    "full_name": "rjgupta/webpack-demo-app",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/webpack-demo-app",
    "description": "Accompanies my 10-part Youtube Webpack course.  Each commit comes with detailed notes.",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/webpack-demo-app",
    "forks_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/webpack-demo-app/deployments",
    "created_at": "2020-03-16T16:35:56Z",
    "updated_at": "2020-03-16T16:35:58Z",
    "pushed_at": "2020-03-14T03:12:52Z",
    "git_url": "git://github.com/rjgupta/webpack-demo-app.git",
    "ssh_url": "git@github.com:rjgupta/webpack-demo-app.git",
    "clone_url": "https://github.com/rjgupta/webpack-demo-app.git",
    "svn_url": "https://github.com/rjgupta/webpack-demo-app",
    "homepage": null,
    "size": 170,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 173797581,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNzM3OTc1ODE=",
    "name": "WhatsApp-Clone",
    "full_name": "rjgupta/WhatsApp-Clone",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/WhatsApp-Clone",
    "description": "A clone of the texting app WhatsApp for learning iOS development with Firebase",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone",
    "forks_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/WhatsApp-Clone/deployments",
    "created_at": "2019-03-04T18:18:37Z",
    "updated_at": "2019-05-10T21:28:39Z",
    "pushed_at": "2019-04-17T20:23:33Z",
    "git_url": "git://github.com/rjgupta/WhatsApp-Clone.git",
    "ssh_url": "git@github.com:rjgupta/WhatsApp-Clone.git",
    "clone_url": "https://github.com/rjgupta/WhatsApp-Clone.git",
    "svn_url": "https://github.com/rjgupta/WhatsApp-Clone",
    "homepage": "",
    "size": 38544,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Swift",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 143644516,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDM2NDQ1MTY=",
    "name": "working-with-Jupyter-Notebook",
    "full_name": "rjgupta/working-with-Jupyter-Notebook",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/working-with-Jupyter-Notebook",
    "description": "Working with and understanding Jupyter Notebook to get insights on Data through various plots.",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook",
    "forks_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/working-with-Jupyter-Notebook/deployments",
    "created_at": "2018-08-05T20:13:34Z",
    "updated_at": "2018-08-11T01:29:03Z",
    "pushed_at": "2018-08-11T01:29:02Z",
    "git_url": "git://github.com/rjgupta/working-with-Jupyter-Notebook.git",
    "ssh_url": "git@github.com:rjgupta/working-with-Jupyter-Notebook.git",
    "clone_url": "https://github.com/rjgupta/working-with-Jupyter-Notebook.git",
    "svn_url": "https://github.com/rjgupta/working-with-Jupyter-Notebook",
    "homepage": null,
    "size": 9482,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Jupyter Notebook",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 162169200,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNjIxNjkyMDA=",
    "name": "You-Dont-Know-JS",
    "full_name": "rjgupta/You-Dont-Know-JS",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/You-Dont-Know-JS",
    "description": "A book series on JavaScript. @YDKJS on twitter.",
    "fork": true,
    "url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS",
    "forks_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/You-Dont-Know-JS/deployments",
    "created_at": "2018-12-17T17:49:51Z",
    "updated_at": "2018-12-17T17:49:54Z",
    "pushed_at": "2018-12-17T11:52:03Z",
    "git_url": "git://github.com/rjgupta/You-Dont-Know-JS.git",
    "ssh_url": "git@github.com:rjgupta/You-Dont-Know-JS.git",
    "clone_url": "https://github.com/rjgupta/You-Dont-Know-JS.git",
    "svn_url": "https://github.com/rjgupta/You-Dont-Know-JS",
    "homepage": "http://www.kickstarter.com/projects/getify/you-dont-know-js-book-series",
    "size": 7285,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 1,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 171320292,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNzEzMjAyOTI=",
    "name": "ZigZag",
    "full_name": "rjgupta/ZigZag",
    "private": false,
    "owner": {
      "login": "rjgupta",
      "id": 24679384,
      "node_id": "MDQ6VXNlcjI0Njc5Mzg0",
      "avatar_url": "https://avatars0.githubusercontent.com/u/24679384?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/rjgupta",
      "html_url": "https://github.com/rjgupta",
      "followers_url": "https://api.github.com/users/rjgupta/followers",
      "following_url": "https://api.github.com/users/rjgupta/following{/other_user}",
      "gists_url": "https://api.github.com/users/rjgupta/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/rjgupta/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/rjgupta/subscriptions",
      "organizations_url": "https://api.github.com/users/rjgupta/orgs",
      "repos_url": "https://api.github.com/users/rjgupta/repos",
      "events_url": "https://api.github.com/users/rjgupta/events{/privacy}",
      "received_events_url": "https://api.github.com/users/rjgupta/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/rjgupta/ZigZag",
    "description": "A 3D Android Game built on Unity 3D with C#",
    "fork": false,
    "url": "https://api.github.com/repos/rjgupta/ZigZag",
    "forks_url": "https://api.github.com/repos/rjgupta/ZigZag/forks",
    "keys_url": "https://api.github.com/repos/rjgupta/ZigZag/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/rjgupta/ZigZag/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/rjgupta/ZigZag/teams",
    "hooks_url": "https://api.github.com/repos/rjgupta/ZigZag/hooks",
    "issue_events_url": "https://api.github.com/repos/rjgupta/ZigZag/issues/events{/number}",
    "events_url": "https://api.github.com/repos/rjgupta/ZigZag/events",
    "assignees_url": "https://api.github.com/repos/rjgupta/ZigZag/assignees{/user}",
    "branches_url": "https://api.github.com/repos/rjgupta/ZigZag/branches{/branch}",
    "tags_url": "https://api.github.com/repos/rjgupta/ZigZag/tags",
    "blobs_url": "https://api.github.com/repos/rjgupta/ZigZag/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/rjgupta/ZigZag/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/rjgupta/ZigZag/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/rjgupta/ZigZag/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/rjgupta/ZigZag/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/rjgupta/ZigZag/languages",
    "stargazers_url": "https://api.github.com/repos/rjgupta/ZigZag/stargazers",
    "contributors_url": "https://api.github.com/repos/rjgupta/ZigZag/contributors",
    "subscribers_url": "https://api.github.com/repos/rjgupta/ZigZag/subscribers",
    "subscription_url": "https://api.github.com/repos/rjgupta/ZigZag/subscription",
    "commits_url": "https://api.github.com/repos/rjgupta/ZigZag/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/rjgupta/ZigZag/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/rjgupta/ZigZag/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/rjgupta/ZigZag/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/rjgupta/ZigZag/contents/{+path}",
    "compare_url": "https://api.github.com/repos/rjgupta/ZigZag/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/rjgupta/ZigZag/merges",
    "archive_url": "https://api.github.com/repos/rjgupta/ZigZag/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/rjgupta/ZigZag/downloads",
    "issues_url": "https://api.github.com/repos/rjgupta/ZigZag/issues{/number}",
    "pulls_url": "https://api.github.com/repos/rjgupta/ZigZag/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/rjgupta/ZigZag/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/rjgupta/ZigZag/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/rjgupta/ZigZag/labels{/name}",
    "releases_url": "https://api.github.com/repos/rjgupta/ZigZag/releases{/id}",
    "deployments_url": "https://api.github.com/repos/rjgupta/ZigZag/deployments",
    "created_at": "2019-02-18T16:44:35Z",
    "updated_at": "2019-04-17T21:23:01Z",
    "pushed_at": "2019-02-27T15:01:08Z",
    "git_url": "git://github.com/rjgupta/ZigZag.git",
    "ssh_url": "git@github.com:rjgupta/ZigZag.git",
    "clone_url": "https://github.com/rjgupta/ZigZag.git",
    "svn_url": "https://github.com/rjgupta/ZigZag",
    "homepage": "",
    "size": 50818,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "C#",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  }
]
